import { Component, OnInit, HostListener } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { NgIf } from '@angular/common';



import { SessionTimeoutDialogComponent } from './app/layout/component/session-timeout-dialog.component';
import { CookieConsentService } from './app/services/cookie-consent.service';
import { TranslateService } from './app/services/translate.service';
import { LayoutService } from './app/layout/service/layout.service';
import { ConfigService } from './app/services/config.service';
import { ViewScopeService } from './app/services/view-scope.service';

import { AuthStateService } from './app/services/auth-state.service';


@Component({
	selector: 'app-root',
	standalone: true,
	imports: [RouterModule, NgIf, SessionTimeoutDialogComponent],
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
	isAuthChecked = false;

	constructor(
		private router: Router,
		private configService: ConfigService,
		public cookieConsentService: CookieConsentService,
		private layoutService: LayoutService,
		public translateServ: TranslateService,
		private viewScopeService: ViewScopeService,
		private authStateService: AuthStateService,
	) { }

	ngOnInit(): void {

		const config = this.layoutService.layoutConfig();
		this.layoutService.toggleDarkMode(config);

		setTimeout(() => {
			this.validateAuthState();
			this.isAuthChecked = true;
		});
	}

	// Routes reachable without being logged in; auth redirect must not run against these.
	private static readonly PUBLIC_ROUTE_PREFIXES = ['/auth', '/landing', '/notfound'];

	// Waits for the same shared session-cookie check the route guards use
	// (AuthStateService.ensureInitialized()) so this can't race ahead with a stale id=0 -
	// see AuthStateService for why that race is real, not theoretical.
	private validateAuthState(): void {
		this.authStateService.ensureInitialized().subscribe(() => {
			const rawId = this.viewScopeService.getCurrentOpertaingUserId();

			if (!rawId || isNaN(rawId) || rawId <= 0) {
				const isPublicRoute = AppComponent.PUBLIC_ROUTE_PREFIXES.some(prefix => this.router.url.startsWith(prefix));
				if (!isPublicRoute) {
					console.warn('AppComponent: No valid ID found → redirecting to landing.');
					// Not allowed in the system → public landing page, not the login form.
					// The login form is reserved for a deliberate sign-out (see ExitService.cleanExit).
					this.router.navigate(['/landing']);
				}
			} else {
				console.log('AppComponent: Valid session detected → continue.');
			}
		});
	}

	@HostListener('window:focus')
	@HostListener('window:pageshow')
	validateAuthStateOnWindowRestore(): void {
		if (this.isAuthChecked) {
			this.validateAuthState();
		}
	}

	@HostListener('document:visibilitychange')
	validateAuthStateOnVisibilityChange(): void {
		if (this.isAuthChecked && document.visibilityState === 'visible') {
			this.validateAuthState();
		}
	}

}
